import React from 'react';
import roseBed from '../../img/rose_bed_lay.png'
import lilyScreenshot from '../../img/lilyscreenshot.png'

const styles = {
  container: {
    backgroundColor: '#f4f4f9', // Light grey background for the feed
    minHeight: '100vh',
    padding: '80px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: '"Inter", sans-serif',
    color: '#333',
  },
  header: {
    textAlign: 'center',
    marginBottom: '60px',
  },
  title: {
    fontSize: '3rem',
    fontWeight: '900',
    marginBottom: '10px',
    color: '#333',
    letterSpacing: '-1px',
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#666',
  },
  feed: {
    width: '100%',
    maxWidth: '800px',
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
  },
  // POST CARD
  postCard: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '0', // Reset padding for image handling
    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
    overflow: 'hidden',
    border: '1px solid #eaeaea',
    transition: 'transform 0.2s',
  },
  postImage: {
    width: '100%',
    height: '300px',
    objectFit: 'cover',
    backgroundColor: '#eee', // Placeholder color
    borderBottom: '1px solid #eaeaea',
  },
  postContent: {
    padding: '40px',
  },
  postMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    fontSize: '0.9rem',
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontWeight: 'bold',
  },
  tag: {
    backgroundColor: '#f0f0f5',
    color: '#b026ff',
    padding: '5px 12px',
    borderRadius: '20px',
    fontSize: '0.8rem',
  },
  postTitle: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '20px',
    lineHeight: '1.3',
    color: '#222',
  },
  postText: {
    fontSize: '1.1rem',
    lineHeight: '1.8',
    color: '#555',
    marginBottom: '20px',
  },
  codeBlock: {
    backgroundColor: '#1a1a1a',
    color: '#00ff00',
    padding: '20px',
    borderRadius: '8px',
    fontFamily: 'monospace',
    fontSize: '0.9rem',
    marginBottom: '20px',
    overflowX: 'auto',
  },
};

// --- MOCK DATA (You can edit this array to add new posts!) ---
const blogPosts = [
  {
    id: 5,
    date: "March 2, 2026",
    tag: "New Project",
    title: "Teasing Our Next Sandbox: LonelyHands",
    image: null, 
    content: (
      <>
        <p>
          While <em>3XRay</em> is our flagship focus, we have another small game that we're close to completing.
          And we're happy to say that we are using a real artist and not AI Generated art for it. 
          The title <b>LonelyHands</b> should sound an awful lot like a particular platform only for fans.
        </p>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={lilyScreenshot} alt='lilyscreenshot' />
        </div>
        <p>
          It’s a work-simulation game where you play as a struggling college student desperate to pay tuition. 
          Your solution? Getting hired as a "ghostwriter" to manage the direct messages for top models on a 
          massive, subscription-based adult platform. 
        </p>
        <p>
          While the bulk of the game plays out on a simulated computer desktop UI, forcing you to juggle clickable apps, 
          an email client, and the main chatter app to progress the story, you aren't glued to the desk. 
          You can step away from the screen to interact with your roommate in your apartment or head out for 
          the office, parks, etc... balancing your digital hustle with your physical reality.
        </p>
        <p>
          We know it might seem ironic for an adult game studio to critique the adult content industry. 
          But to us, the distinction is massive. There is a world of difference between a player paying a flat 
          indie price for a crafted, fictional narrative experience, and a platform using predatory, parasocial 
          tactics to squeeze endless funds out of financially vulnerable people.
        </p>
        <p>
          <em>LonelyHands</em> explores that dark grey area. When your survival is on the line, how far will you 
          go to manipulate a stranger on the other side of the screen?
        </p>
      </>
    )
  },
  {
    id: 3,
    date: "February 14, 2026",
    tag: "Tech Art",
    title: "Implementing the X-Ray Cursor",
    image: null, 
    content: (
      <>
        <p>
          One of the core mechanics of 3XRay is the ability to see through the facade (literally). 
          We didn't want a simple "Toggle Switch" UI; we wanted it to feel tactile.
        </p>
        <p>
          On <a href="/games/3xr" style={{color: '#b026ff', fontWeight: 'bold', textDecoration: 'none'}}>3XRay's page</a>, we implemented a CSS masking system that tracks the mouse position in real-time. 
          It stacks two images, the "Public" layer and the "Secret" layer, and cuts a hole in the top one.
        </p>
        <div style={styles.codeBlock}>
          mask-image: radial-gradient(circle 150px at cursorX cursorY, transparent, black);
        </div>
        <p>
          It's not new technology, but it was fun and surprisingly easy to build, and really gives the page a nice interactive and
          interesting 'pop'. Go check it out!
        </p>
      </>
    )
  },
  {
    id: 2,
    date: "February 6, 2026",
    tag: "Announcement",
    title: "Project Reveal: 3XRay",
    image: null, 
    content: (
      <>
        <p>
          It is time to officially pull the curtain back on our first large scale title: <b>3XRay</b>.
        </p>
        <p>
          Set in the prestigious (and deeply corrupt) St. Aethelgard University, the game kicks off 
          when you suffer a humiliating public defeat at the hands of a delinquent student named Anna. But that night,
          your luck changes. A succubus named Akala visits you with a devilish offer, granting you the power of X-Ray
          vision to beat Anna at her own game, and uncover so much more.
        </p>
        <p>
          We are using Spine for animation on the more 'spicy' parts of the game to give our character 
          animations a smooth, breathing life that static images just can't capture. With over 20 heroines 
          planned, the core of the game is about moral choices. Will you use your newfound vision to uncover 
          conspiracies and help your classmates, or will you use their darkest secrets against them?
        </p>
        <img src={roseBed} alt='rose'/>
        <p>
          Stay tuned. We have a lot of mechanics to show off in the coming weeks.
        </p>
      </>
    )
  },
  {
    id: 1,
    date: "January 30, 2026",
    tag: "Studio",
    title: "Welcome to Foreplay Games",
    image: null,
    content: (
      <>
        <p>
          Hello world! We are officially launching our site and our studio. 
          Our goal is simple: create adult games with meaning and narrative depth. A slow burn as opposed to 'quick and dirty'.
        </p>
        <p>
          We want to make more than just linear "click to advance" visual novels with zero interaction.
          We are hoping to build systems, mechanics, and worlds with more meaning and purpose, rather than a 'quick fap'. 
          A 'slow burn' is the best way to describe how we want our games to play, and while that might not be
          everyone's cup of tea, we believe that 'foreplay' (or rather, the game's progression towards the eventual sex scene, 
          hence our studio's name) is important, and having that be part of the experience, the buildup, makes the payoff so much
          more satisfying, assuming it is built well. That's what we will be striving for.
        </p>
      </>
    )
  }
];

export default function DevlogPage() {
  return (
    <div style={styles.container}>
      
      <div style={styles.header}>
        <h1 style={styles.title}>Developer Log</h1>
        <p style={styles.subtitle}>Updates, sketches, and technical deep-dives.</p>
      </div>

      <div style={styles.feed}>
        {blogPosts.map((post) => (
          <div key={post.id} style={styles.postCard}>
            
            {/* Conditional Rendering: Only show image box if post.image exists */}
            {post.image && (
              <img src={post.image} style={styles.postImage} alt={post.title} />
            )}

            <div style={styles.postContent}>
              <div style={styles.postMeta}>
                <span>{post.date}</span>
                <span style={styles.tag}>{post.tag}</span>
              </div>
              
              <h2 style={styles.postTitle}>{post.title}</h2>
              
              <div style={styles.postText}>
                {post.content}
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}